import { render } from "./buyAllButton.vue?vue&type=template&id=40ef29d8"
import script from "./buyAllButton.vue?vue&type=script&lang=js"
export * from "./buyAllButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__